<template>
    <div class="flex flex-col h-screen">
        <div class="ds-side-panel-content flex-1 py-4 overflow-y-auto">
            <div class="ds-employee-panel-title ds-employee-panel-title-spacing">Карточка сотрудника</div>
            <div class="ds-employee-summary ds-employee-summary-spacing">
                <Avatar :url="avatar" :first-name="user.first_name" :last-name="user.last_name" size="md" />
                <div>
                    <div class="ds-employee-summary-name">{{ fullName }}</div>
                    <div class="ds-employee-form-data-label" v-if="position">{{ position.name }}</div>
                    <div class="ds-employee-form-data-label">{{ department?.name }}</div>
                </div>
            </div>
            <EmployeesData :user class="mb-5" @edit="emit('user-edit')" />
            <Tabs :tabs="tabs" tab-margin-right="22" class="ds-employee-card-tabs">
                <template #employments>
                    <EmploymentsTabs :employments @fired="emit('fired')" :archive />
                </template>
                <template #settings>
                    <EmployeeSettings :user />
                </template>
            </Tabs>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Avatar from '../Avatar.vue'
import dayjs from "dayjs"
import EmployeesData from './EmployeesData.vue' 
import EmploymentsTabs from './EmploymentsTabs.vue'
import EmployeeSettings from './EmployeeSettings.vue'
import Tabs from '@/components/Tabs.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useEmploymentStore } from '@/stores/employmentStore'
import { useAuthStore } from '@/stores/authStore'
import type { Tab } from '@/types'

dayjs.locale('ru')

interface Props {
    archive: boolean
}

const { archive } = defineProps<Props>()

const departmentStore = useDepartmentStore()
const scheduleStore = useScheduleStore()
const employmentStore = useEmploymentStore()
const authStore = useAuthStore()
const emit = defineEmits(['fired', 'user-edit'])

const user = computed(() => employmentStore.user)
const fullName = computed(() => {
    const ln:string = (user.value.last_name) ? user.value.last_name : ''
    const fn:string = (user.value.first_name) ? user.value.first_name : ''
    const mn:string = (user.value.middle_name) ? user.value.middle_name : ''
    return `${ln} ${fn} ${mn}`
})
const avatar = computed(() => user.value.avatar)
const employments = computed(() => user.value.employments)
const mainEmployment = user.value.employments[0]
const position = computed(() => scheduleStore.positions.find(item => item.id === mainEmployment.position))
const department = computed(() => departmentStore.departments.find(item => item.id === mainEmployment.department))
const tabs = computed<Tab[]>(() => {
    const result: Tab[] = [{ name: 'employments', label: 'Трудоустройства' }]

    if (authStore.permissions?.can_reset_user_password) {
        result.push({ name: 'settings', label: 'Настройки' })
    }

    return result
})

</script>
